export const ACTION_SET_ALERT = 'ACTION_PUSH_ALERT'

export const SET_ALERT = 'PUSH_ALERT'

export const ALERT_KEY = 'alert'
